import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaPhoneAlt, FaChevronDown, FaBars, FaTimes } from "react-icons/fa";
import logo from "../Assets/Images/asvf-logo.png";
import "../styles/Navbar.css";

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { title: "Home", path: "/" },
    { title: "About Us", path: "/about" },
    {
      title: "Administration",
      submenu: [
        { title: "Messages", path: "/administration/messages" },
        { title: "Staff Information", path: "/administration/staff-information" },
      ],
    },
    {
      title: "Academic",
      submenu: [
        { title: "Dress Code", path: "/academic/dress-code" },
        { title: "Code of Conducts", path: "/academic/code-of-conduct" },
        { title: "Guideline for Parents", path: "/academic/guideline-for-parents" },
        { title: "Academic Calendar", path: "/academic/academic-calendar" },
        { title: "Activities Calendar", path: "/academic/activities-calendar" },
      ],
    },
    {
      title: "Facilities",
      submenu: [
        { title: "Scholarship", path: "/facilities/scholarship" },
        { title: "Hostel", path: "/facilities/hostel" },
        { title: "Medical", path: "/facilities/medical" },
        { title: "Library", path: "/facilities/library" },
        { title: "Laboratories", path: "/facilities/laboratories" },
        { title: "Clubs", path: "/facilities/clubs" },
        { title: "School Bus", path: "/facilities/school-bus" },
        { title: "Play Ground", path: "/facilities/play-ground" },
      ],
    },
    {
      title: "Gallery",
      submenu: [
        { title: "Photos", path: "/gallery/photos" },
        { title: "Videos", path: "/gallery/videos" },
      ],
    },
    {
      title: "Result",
      submenu: [
        { title: "Vocational School", path: "/results/vocational-school" },
        { title: "Training Centre", path: "/results/training-centre" },
      ],
    },
    { title: "Notice", path: "/notice" },
    {
      title: "Admission",
      submenu: [
        { title: "Admission Info", path: "/admission/admission-info" },
        { title: "Admission Form", path: "/admission/admission-form" },
        { title: "Fees & Payment", path: "/admission/fees-payment" },
        { title: "Apply Online", path: "/admission/apply-online-page" },
      ],
    },
    { title: "Contact", path: "/contact" },
  ];

  return (
    <header className="main-header-home">
      {/* -------- Top Section -------- */}
      <div className="nav-container-home">
        <Link to="/" className="logo-link-home" onClick={() => setMobileMenuOpen(false)}>
          <img src={logo} alt="Akij Foundation Vocational School" className="main-logo-home" />
          <span className="school-name">
            <span className="school-name-main">Akij Foundation Vocational School</span>
          </span>
        </Link>

        <div className="header-right-section-home">
          <div className="email-block-home">
            <span className="email-label-home">Call Now For Admission</span>
            <div className="email-link-home">
              <FaPhoneAlt className="email-icon-home" /> +880 1318396744
            </div>
          </div>
        </div>

        {/* Mobile Toggle Button */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* -------- Bottom Menu Section -------- */}
      <nav className={`menu-bar ${mobileMenuOpen ? "active" : ""}`}>
        <ul className="menu-list">
          {menuItems.map((item, index) => (
            <li
              key={index}
              className={`menu-item ${
                location.pathname === item.path ? "active" : ""
              } ${item.submenu ? "has-dropdown" : ""}`}
            >
              {item.submenu ? (
                <span className="menu-link-home">
                  {item.title}
                  <FaChevronDown className="dropdown-icon-home" />
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="menu-link-home"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.title}
                </Link>
              )}

              {item.submenu && (
                <ul className="dropdown-menu-home">
                  {item.submenu.map((sub, subIndex) => (
                    <li key={subIndex}>
                      <Link
                        to={sub.path}
                        onClick={() => setMobileMenuOpen(false)}
                        className={
                          location.pathname === sub.path ? "active-sub" : ""
                        }
                      >
                        {sub.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;
